import { Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'core-delete-account',
  templateUrl: './delete-account.component.html',
  imports: [MatDividerModule, MatButtonModule],
  standalone: true,
})
export class DeleteAccountCoreComponent {
  deleteAccount = output<void>();
}
